import React, { useState, useCallback, useEffect } from 'react';
import service from '../../../../services/pedidos';
import { date2Front, datetime2Front } from '../../../../utils/converts';
import { formatCurrency } from '../../../../utils/Money';
import Listagem from './Listagem';
import { useSelector } from 'react-redux';

const PedidosListagem = props => {
    const profile = useSelector(state => state.auth.profile);
    const rota = "pedidos-venda-revendedora";
    let config;

    if (props.compra) {
        config = {
            columns: [
                { label: "Nº", field: "sequencia" },
                { label: "Nota Fiscal", field: "numeroNf" },
                { label: "Valor total", field: "valorTotal", convert: formatCurrency },
                { label: "Pontos", field: "pontosTotal", convert: formatCurrency },
                { label: "Data criado", field: "createAt", convert: datetime2Front },
                { label: "Data entrega", field: "dataEntrega", convert: date2Front },
            ],
            pagination: {
                limit: 10
            },
            sort: '-createAt',
            search: [
                { label: 'Nº', field: 'sequencia', operators: ['equal'] }
            ]
        }
    } else {
        config = {
            columns: [
                { label: "Nº", field: "sequencia" },
                { label: "Catálogo", field: "catalogo.nome" },
                { label: "Criador por", field: "criadoPor.nome" },
                { label: "Data criado", field: "createAt", convert: datetime2Front },
                { label: "Revendedora", field: "usuario.nome" },
                { label: "Valor total", field: "valorTotal", convert: formatCurrency },
            ],
            pagination: {
                limit: 50
            },
            sort: '-createAt',
            search: [
                { label: 'Nº', field: 'sequencia', operators: ['equal'] },
                // { label: 'Catálogo', field: 'catalogos.nome', operators: ['contains', 'not_contains'] },
            ]
        }
    }

    const [registros, setRegistros] = useState({ rows: [], total: 0 });
    const [loadingList, setLoadingList] = useState(true);

    const getList = useCallback(async (params, skip) => {
        setLoadingList(true);
        if (props.compra) {
            params.push({ field: "tipo", operator: "equal", value: "Compra" });
        } else {
            params.push({ field: "tipo", operator: "equal", value: "Venda" });
        }
        params.push({field: "usuario", operator: "equal", value: profile._id});
        const result = await service.getList({ params, sort: config.sort }, skip, config.pagination.limit);
        setLoadingList(false);
        setRegistros(result);
    }, [config.pagination.limit, config.sort, rota]);

    const upsert = async (obj, id) => {
        setLoadingList(true);
        const result = await service.upsert(obj, id);
        setLoadingList(false);
        return result;
    }

    const cancelar = async (id) => {
        setLoadingList(true);
        const result = await service.get(`cancel/${id}`);
        setLoadingList(false);
        return result;
    }
    
    useEffect(() => {
        getList([], 0);
    }, [getList]);

    return (
        <>
            <Listagem registros={registros} service={{ getList, upsert, cancelar }}
                config={config} loadingList={loadingList} rota={rota} compra={props.compra} />
        </>
    )
}

export default PedidosListagem;